import AppContainer from './Container';
import bootstrap from '~/common/bootstrap';

export default bootstrap(AppContainer);
